export default __webpack_public_path__ + "static/GT-America-Standard-Regular-a7c05d5fa56d00ca006c24bfe8ceeac8.woff2";